import React, {Component} from 'react';
import Oevelse from "./Oevelse";
import {Link} from 'react-router-dom'
import {ResultService} from "../../services/resultService";
import SelectListPartiKlasseOption from "../../SelectKlassePartiListOption";
import {PersistService} from "../../services/persistService";

const $ = window.$;

class Kritik extends Component {

    constructor(props) {
        super(props);
        this.state = {
            deltaker : null,
            oevelser : [],
            klassePartier: [],
            selectedParti: "",
            changingKlasse : false,
            deltPaaOevelser : false,
            delPartiCheckedIn: null,
            underKlassePartier: [],
            fraOevelse: null,
            tilOevelse: null,
            internasjonal: null
        }
        this.poengOppdatert = this.poengOppdatert.bind(this);
        this.kommentarOppdatert = this.kommentarOppdatert.bind(this);
        this.renderKritikk = this.renderKritikk.bind(this);
        this.renderFooter = this.renderFooter.bind(this);
        this.renderTilbakeOgNesteButtons = this.renderTilbakeOgNesteButtons.bind(this);
        this.loadDeltakerOgOevelser = this.loadDeltakerOgOevelser.bind(this);
        this.loadKlasserSomDetKanByttesTil = this.loadKlasserSomDetKanByttesTil.bind(this);
        this.handleKortChange = this.handleKortChange.bind(this);
        this.handleSelectedPartiChange = this.handleSelectedPartiChange.bind(this);
        this.getNeste = this.getNeste.bind(this);
        this.getForrige = this.getForrige.bind(this);
        this.openChangeKlasse = this.openChangeKlasse.bind(this);
        this.closeChangeKlasse = this.closeChangeKlasse.bind(this);
        this.renderChangeKlasse = this.renderChangeKlasse.bind(this);
        this.byttKlasse = this.byttKlasse.bind(this);
    }

    componentDidMount() {
        if (this.props.partiLoaded) {
            this.loadDeltakerOgOevelser(this.props.match.params.id);
            window.scrollTo(0, 0);
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((!this.props.partiLoaded && nextProps.partiLoaded)
        || (this.props.match.params.id !== nextProps.match.params.id)) {
            this.loadDeltakerOgOevelser(nextProps.match.params.id);
            window.scrollTo(0, 0);
        }
    }

    renderFooter() {
        return (

            <nav className="navbar navbar-default navbar-fixed-bottom">
                <div className="container">
                    <Link to="/">
                        <button className="btn btn-primary navbar-btn">Til deltager oversigt</button>
                    </Link>

                    {this.renderTilbakeOgNesteButtons()}

                </div>
            </nav>
        )

    }

    renderChangeKlasse() {
        const {deltaker, klassePartier, selectedParti} = this.state;
        if (deltaker !== null) {

            let changePartiKlasseBtnClass = "btn btn-primary has-spinner";
            if (this.state.changingParti) {
                changePartiKlasseBtnClass += " active";
            }
            let disableNyKlasseBtn = true;
            if (selectedParti !== '') {
                disableNyKlasseBtn = false;
            }

            return (
                <div id="myModal" className="modal fade" role="dialog">
                    <div className="modal-dialog">

                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" >
                                    <span aria-hidden="true">&times;</span><span className="sr-only">Close</span></button>
                                <h4 className="modal-title" id="myModalLabel">
                                    Ændre klasse for {deltaker.katalogNr} - {deltaker.regNr}</h4>

                            </div>
                            <div className="modal-body">
                                Ny klasse:
                                <select className="form-control"  onChange={this.handleSelectedPartiChange}>
                                    <option value=""></option>
                                    {
                                        klassePartier.map(klasseParti =>
                                            <SelectListPartiKlasseOption key={klasseParti.partiId} klasseParti={klasseParti} />
                                        )
                                    }
                                </select>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" data-dismiss="modal">Luk</button>
                                <button type="button" className={changePartiKlasseBtnClass} disabled={disableNyKlasseBtn} onClick={this.byttKlasse} >
                                    <span className="spinner"><i className="fa fa-refresh fa-spin"></i></span>
                                    Gem
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            )
        }
        return null;
    }

    renderTilbakeOgNesteButtons() {
        const {deltaker} = this.state;
        if (deltaker !== null) {
            return (
                <div className="navbar-right">
                    <button onClick={this.getForrige} className="btn btn-primary navbar-btn"> Forrige </button>
                    &nbsp;
                    <button onClick={this.getNeste} className="btn btn-primary navbar-btn"
                            focus-on="focusNeste"> Gem/Næste </button>
                </div>
            )
        }
        return null;
    }


    renderKritikk() {

        const {oevelser, deltaker, fraOevelse, tilOevelse, delPartiCheckedIn, underKlassePartier} = this.state;
        if (deltaker !== null) {

            const poengTotalt = deltaker.resultat.poengTotalt;
            const ikkeMoedt = deltaker.resultat.ikkeMoedt;
            const gultKort =  deltaker.resultat.gultKort;
            const roedtKort =  deltaker.resultat.roedtKort;
            let disableGultKort = false;
            let disableRoedtKort = false;
            if (ikkeMoedt || delPartiCheckedIn) {
                disableGultKort = true;
                disableRoedtKort = true;
            } else if (roedtKort) {
                disableGultKort = true;
            }

            return (


                <div className="row">

                    <div className="col-sm-12" >
                        <div className="row">
                            <div className="col-sm-10" >
                                <h3>{deltaker.katalogNr}</h3>
                                <h4>{deltaker.regNr} - {deltaker.navn}</h4>
                            </div>
                            {
                                !this.state.internasjonal &&
                                <div className="col-sm-2"  >
                                    <button className="btn btn-primary navbar-btn" data-toggle="modal" data-target="#myModal" onClick={this.loadKlasserSomDetKanByttesTil}> Ændre klasse</button>

                                </div>
                            }

                        </div>

                        <div className="row boxed">
                            <table width="100%" className="kritikk-table" cellSpacing="0">
                                <tbody>
                                <tr>
                                    <th align="left" width="35%">
                                        <span>Øvelse</span>
                                    </th>
                                    <th colSpan="3"  className="r b l"><span className="center-text">Points</span></th>
                                    <th width="50%" align="center">
                                        <span className="center-text">Dommerkommentarer</span>
                                    </th>
                                </tr>
                                <tr>
                                        <th></th>
                                        <td align="center" className="l">Koeff</td>
                                        <td align="center" className="l">Opnået</td>
                                        <td align="center" className="r l">I alt</td>
                                        <th></th>
                                </tr>
                                {
                                    oevelser.map(oevelse => <Oevelse key={oevelse.nr}
                                                                     fraOevelse={fraOevelse}
                                                                     tilOevelse={tilOevelse}
                                                                     delPartiCheckedIn={delPartiCheckedIn}
                                                                     underKlassePartier={underKlassePartier}
                                                                     roedtKort={roedtKort}
                                                                     ikkeMoedt={ikkeMoedt}
                                                                     oevelse={oevelse}
                                                                     poengTotalt={poengTotalt}
                                                                     poengOppdatert={this.poengOppdatert}
                                                                     kommentarOppdatert={this.kommentarOppdatert}/> )
                                }
                                <tr>
                                    <td align="left" valign="top"><strong>Gult kort</strong></td>
                                    <td align="center">
                                        <input type="checkbox" className="large-checkbox" name="G" onChange={this.handleKortChange} disabled={disableGultKort} checked={gultKort} />
                                    </td>
                                    <td colSpan="3">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td align="left" valign="top"><strong>Rødt kort</strong></td>
                                    <td align="center">
                                        <input type="checkbox" className="large-checkbox" name="R" onChange={this.handleKortChange}  disabled={disableRoedtKort} checked={roedtKort} />
                                    </td>
                                    <td colSpan="3">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td align="left" valign="top"><span className="visible-xs">Opnået i alt</span></td>

                                    <td align="center"></td>
                                    <td align="center"></td>
                                    <td align="center">
                                        <span>
                                            {!roedtKort &&
                                                poengTotalt
                                            }
                                        </span>
                                    </td>
                                    <td colSpan="3">&nbsp;</td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


            );
        }
        return null;

    }

    render() {
        const { deltaker } = this.state;

        return (
            <div>
                <div className="container">
                    <br/>
                    {
                        deltaker === null && (
                            <div className="row boxed">
                                <div className="col-sm-12">
                                    <h4>Det finnes ingen deltager med katalognr <code>{(this.props.match.params.id)}</code></h4>
                                </div>
                            </div>
                        )
                    }
                    {this.renderChangeKlasse()}


                    {this.renderKritikk()}


                </div>

                {this.renderFooter()}

            </div>
        );
    }

    getForrige() {
        const katalogNr = this.state.deltaker.katalogNr;
        var forrigeKatalogNr = ResultService.getForrige(katalogNr, true);
        if (forrigeKatalogNr) {
            window.location.hash = "/kritik/" + forrigeKatalogNr;
            //this.props.history.push('/kritik/' + forrigeKatalogNr);
        }
        else {
            window.location.hash = "/";
            //this.props.history.push('/');
        }
    }

    getNeste() {
        const katalogNr = this.state.deltaker.katalogNr;
        var nesteKatalogNr = ResultService.getNeste(katalogNr, true);
        if (nesteKatalogNr) {
            //this.props.history.push('/kritik/' + nesteKatalogNr);
            window.location.hash = "/kritik/" + nesteKatalogNr;
        }
        else {
            window.location.hash = "/";
            //this.props.history.push('/');
        }
    }

    openChangeKlasse() {
        this.setState({ showChangeKlasseModal: true });
    }

    closeChangeKlasse() {
        this.setState({ showChangeKlasseModal: false });
    }

    kommentarOppdatert(nr, kommentar) {
        const katalogNr = this.state.deltaker.katalogNr;
        ResultService.oppdaterKommentar(katalogNr, nr, kommentar);
        this.setState(() => ({
            oevelser : ResultService.getKritikkOevelserTilDeltaker(katalogNr).slice()
        }));
    }

    poengOppdatert(nr, poeng) {
        const katalogNr = this.state.deltaker.katalogNr;
        ResultService.oppdaterPoeng(katalogNr, nr, poeng);
        this.setState(() => ({
            oevelser : ResultService.getKritikkOevelserTilDeltaker(katalogNr).slice()
        }));
    }

    loadDeltakerOgOevelser(katalogNr) {

        this.setState(() => ({
            deltaker : ResultService.getDeltaker(katalogNr),
            oevelser : ResultService.getKritikkOevelserTilDeltaker(katalogNr).slice(),
            deltPaaOevelser: ResultService.isKlasseDeltPaaOevelser(),
            fraOevelse: ResultService.getFraOevelse(),
            tilOevelse:  ResultService.getTilOevelse(),
            delPartiCheckedIn: ResultService.getDelPartiCheckedIn(),
            underKlassePartier: ResultService.getUnderKlassePartier(),
            internasjonal:  ResultService.isInternasjonal()
        }));
    }

    loadKlasserSomDetKanByttesTil(e) {
        e.preventDefault();
        const klasse = ResultService.getKlasse();
        PersistService.getKlassePartier(ResultService.getParti().proeveId, ResultService.getParti().passord)
            .then((klassePartier)=>{
                let ret = [];
                for (var i = 0; i < klassePartier.length; i++) {
                    if (klassePartier[i].hovedparti &&  klassePartier[i].klasse.klasseId !== klasse.klasseId) {
                        ret.push(klassePartier[i]);
                    }

                }

                this.setState(() => ({
                    klassePartier : ret
                }));
            })
            .catch((err)=> {
                alert(err.message);
            });
    }

    byttKlasse() {
        this.setState(() => ({
            changingKlasse : true
        }));
        const katalogNr = this.state.deltaker.katalogNr;
        const lnr = this.state.deltaker.lnr;
        const selectedParti = this.state.selectedParti;

        ResultService.changeKlasseParti(katalogNr, lnr, selectedParti)
            .then((parti)=>{
                this.setState(() => ({
                    changingKlasse : false,
                    selectedParti: ''
                }));
                document.body.classList.remove("modal-open");
                $('#myModal').modal('hide');
                //this.props.history.push('/');
                window.location.hash = "/";
            })
            .catch((err)=> {
                alert(err.message);
                this.setState(() => ({
                    changingKlasse: false
                }));
            })
    }

    handleKortChange(event) {
        const katalogNr = this.state.deltaker.katalogNr;
        if (event.target.name === 'G') {
            ResultService.oppdaterGultKort(katalogNr, event.target.checked);
        }
        else {
            ResultService.oppdaterRoedtKort(katalogNr, event.target.checked);
        }
        this.setState(() => ({
            deltaker : ResultService.getDeltaker(katalogNr)
        }));
    }

    handleSelectedPartiChange(event) {
        this.setState({selectedParti: event.target.value});
    }





}

export default Kritik;





// WEBPACK FOOTER //
// ./src/pages/kritikk/Kritikk.js